import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { FDTextButton } from '@facet-wealth/design';

const SetupManually = ({
  resource,
  onLoadLink,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const shouldAllowManual = resource.withRelationship(fr.relationships.addManually.name,
    () => true,
    () => false);

  if (!shouldAllowManual) {
    return null;
  }

  const handleOnClick = async () => {
    logStandardizedEvent(categories.addAccounts, eventTypes.selectInstitution, eventSubTypes.addAccountsManually, {
      eventProperties: {
        institution: resource.attr('institutionName'),
      },
    });
    const addManuallyLink = resource?.relationship(fr.relationships.addManually.name)?.link('related');
    if (addManuallyLink) {
      onLoadLink(addManuallyLink);
    }
  };

  return (
    <FDTextButton
      onClick={handleOnClick}
      data-test="add-manually-button"
      label="Set up manually instead"
    />
  );
};

SetupManually.defaultProps = {
};

SetupManually.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onLoadLink: PropTypes.func.isRequired,
};

export default SetupManually;
